import React, { memo } from 'react'
import PropTypes from 'prop-types'
import LazyLoad from 'react-lazyload'
import './index.scss'

const DetailQA = ({ introductions }) => (
  <>
    <div
      className="r-detail-qa"
      data-exposure="car-detail_carqa_display"
    >
      <h2 className="r-detail-qa__title">严选车是什么?</h2>
      <ul className="r-detail-qa__main clearfix">
        {introductions && introductions.map(introduction => (
          <li className="item" key={introduction?.title}>
            <div className="item-icon">
              <LazyLoad><img src={introduction?.imageurl} alt={introduction?.title || '严选车介绍'} /></LazyLoad>
            </div>
            <div className="item-txt">
              <h4>{introduction?.title}</h4>
              <p>{introduction?.content}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  </>
)

export default memo(DetailQA)
DetailQA.propTypes = {
  introductions: PropTypes.array
}

DetailQA.defaultProps = {
  introductions: []
}
